import React from 'react';
import {
    FaDice,
    FaFire,
    FaStar,
    FaVideo,
    FaBolt,
    FaCoins,
    FaGem,
    FaGift,
    FaRocket,
    FaTrophy,
    FaHeart,
    FaClock
} from 'react-icons/fa';

// Маппинг строковых названий иконок на React компоненты
const iconComponents = {
    dice: FaDice,
    fire: FaFire,
    star: FaStar,
    video: FaVideo,
    bolt: FaBolt,
    coins: FaCoins,
    gem: FaGem,
    gift: FaGift,
    rocket: FaRocket,
    trophy: FaTrophy,
    heart: FaHeart,
    clock: FaClock
};

/**
 * Получить React компонент иконки по строковому названию
 * @param {string} iconName - название иконки
 * @returns {React.Component} - React компонент иконки
 */
export const getIcon = (iconName) => {
    const IconComponent = iconComponents[iconName];
    return IconComponent ? <IconComponent /> : <FaDice />;
};

/**
 * Проверить, существует ли иконка
 * @param {string} iconName - название иконки
 * @returns {boolean} - существует ли иконка
 */
export const hasIcon = (iconName) => {
    return iconName in iconComponents;
};
